import moment from 'moment';

const monthList = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

const getDateMonth = dateString => {
  return monthList[parseInt(dateString.split('/')[1], 0) - 1];
};

const formatDateReadable = dateString => {
  const dateParts = dateString.split('/');
  return `${dateParts[0]} de ${getDateMonth(dateString)} de ${dateParts[2]}`;
};

const stringToDate = dateString => {
  const dateParts = dateString.split('/');
  const [day, month, year] = dateParts;
  const newDate = new Date(+year, month - 1, +day, 23, 59, 59);
  return newDate;
};

const getExpirationDateMessage = expirationDate => {
  const currentTime = new Date().getTime();
  const expirationTime = stringToDate(expirationDate).getTime();
  const timeRemaining = expirationTime - currentTime;
  const millisecondsPerDay = 1000 * 3600 * 24;
  let daysRemaining = Math.ceil(timeRemaining / millisecondsPerDay);
  daysRemaining = daysRemaining < 0 ? 0 : daysRemaining;

  let message = 'Para Siempre';

  if (daysRemaining <= 1) {
    message = 'Vence hoy';
  }

  if (daysRemaining > 1 && daysRemaining <= 2) {
    message = 'Vence mañana';
  }

  if (daysRemaining > 2 && daysRemaining <= 2159) {
    message = `Vigencia: ${expirationDate}`;
  }

  return message;
};

const secondsToString = sec => {
  const seconds = typeof sec === 'number' ? sec : parseInt(sec, 0);
  const str = new Date(seconds * 1000).toISOString().substr(11, 8);
  return str;
};

const fromUTCDateToCustomFormat = (UTCDate, customFormat = null) =>
  customFormat === null ? UTCDate : moment(UTCDate).format(customFormat);

const formatDateString = date => {
  const year = date.slice(0, 4);
  const month = date.slice(5, 7);
  const day = date.slice(8, 10);
  const fechaFormateada = `${day}/${month}/${year}`;
  return fechaFormateada;
};
const dateDifference = (from, to, differenceFormat) => {
  const date1 = moment(to.date, to.format);
  const date2 = moment(from.date, from.format);

  return date1.diff(date2, differenceFormat);
};

const addTimeToDate = (dateString, timeValue, timeUnit) => {
  const originalDate = moment(dateString, 'YYYY-MM-DD');
  const newDate = originalDate.add(timeValue, timeUnit);
  return newDate;
};

export {
  getDateMonth,
  formatDateReadable,
  stringToDate,
  getExpirationDateMessage,
  secondsToString,
  fromUTCDateToCustomFormat,
  formatDateString,
  dateDifference,
  addTimeToDate,
};
